import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface BenefitItem {
  ID: number;
  BenefitTitle: string;
  ImagePath: string;
  DisplayOrder: number;
  IsActive: boolean;
}

@Component({
  selector: 'app-benefits',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './benefits.html',
  styleUrl: './benefits.css',
})
export class Benefits implements OnInit {
  private http = inject(HttpClient);

  // Base address of your API site (no trailing slash, no /api)
  private readonly apiBase = 'https://crm-api.redmonkwellness.com';

  benefits = signal<BenefitItem[]>([]);
  loading = signal(true);
  error = signal(false);

  ngOnInit(): void {
    this.http
      .post<{ success: boolean; Items: BenefitItem[] }>(`${this.apiBase}/Team/GetBenefits`, {})
      .subscribe({
        next: (res) => {
          if (res.success) {
            const list = (res.Items || [])
              .filter((b) => b.IsActive)
              .sort((a, b) => a.DisplayOrder - b.DisplayOrder);
            this.benefits.set(list);
          } else {
            this.error.set(true);
          }
          this.loading.set(false);
        },
        error: () => {
          this.error.set(true);
          this.loading.set(false);
        },
      });
  }

  // Saved paths look like /Uploads/AboutBenifit/xxx.png (relative to the API site)
  imgUrl(path: string): string {
    if (!path) return '';
    return /^(https?:|data:)/i.test(path) ? path : this.apiBase + path;
  }
}